import Axios from 'axios'

const { REACT_APP_ASSIGNATION_API = 'https://develop-api-assignation.egg.live' } = process.env

export const ApiAssignation = Axios.create({
    baseURL: REACT_APP_ASSIGNATION_API,
})

export const postRequestExpertMentor = () =>
    ApiAssignation.post<API<{}>>('/assign/assignation/assign_hr').then(({ data }) => data)

export const leaveHelpRequest = () =>
    ApiAssignation.post<API<{}>>('/assign/assignation/unassign_hr').then(({ data }) => data)

export const fetchExpertMentors = () =>
    ApiAssignation.get<API<ExpertMentorsDTO>>('/assign/assignation/mentor_status').then(({ data }) => data)

// Interfaces
type API<T> = T

export type LeaveHRResponseDTO = {}

export type ExpertMentorsDTO = {
    mentors: {
        availables: MentorsDTO[]
        busy: MentorsDTO[]
        unavailable: MentorsDTO[]
    }
}

export type MentorStatusDTO = keyof ExpertMentorsDTO['mentors']

export type MentorsDTO = {
    profileId: string
    status: MentorStatusDTO
    teamNumber?: number
}
